module.exports = __webpack_public_path__ + "img/mood_devil.6043337e.png";